export const ApiBatchRejectSpaces = Symbol('ApiBatchRejectSpaces');
